import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import styles from './styles';

type RBIErrorPopupProps = {
  isOpen: boolean;
  messageHeader?: string;
  message?: string | Element | React.ReactFragment;
  cleanUp?: () => void;
  closeModal: () => void;
  footerText: string;
};

export default function RBIErrorPopup(props: RBIErrorPopupProps) {
  const classes = styles();

  const {
    isOpen,
    message: messageText,
    messageHeader,
    cleanUp: cleanUpFunction,
    closeModal,
    footerText,
  } = props;

  const handleCloseModal = (): void => {
    if (cleanUpFunction) cleanUpFunction();
    closeModal();
  };

  return (
    <Dialog
      onClose={handleCloseModal}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      disableBackdropClick={true}
      className={classes.viewModal}
    >
      <DialogTitle id="customized-dialog-title" className={classes.errorTitle}>
        <Grid container justifyContent="space-between">
          <Grid item>
            <Typography variant="h6" style={{ fontWeight: 600 }}>
              {messageHeader}
            </Typography>
          </Grid>
          <Grid item>
            <IconButton style={{ padding: 0 }} onClick={handleCloseModal}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent className={classes.modalContent}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
          spacing={2}
          style={{ width: '100%', height: '100%', alignSelf: 'center' }}
        >
          <Grid item xs={10} style={{ textAlign: 'start' }}>
            <Typography variant="body1">{messageText} </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.panel}>
        <Button
          variant="contained"
          className={classes.button}
          color="primary"
          autoFocus
          onClick={handleCloseModal}
        >
          {footerText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
